var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useRef, useEffect } from 'react';
import { Falcon } from 'modules/macro';
import { useGeneratedId, useForkedRef } from 'modules/utils';
import { Container, InputContainer, Input, Label } from '../../styled';
import { FragmentWithoutProps } from '../FragmentWithoutProps';
import { StyledOverlay } from './styled';
const minusIconMap = new Map([
    ['small', <Falcon key={0} icon="minus" $size={8}/>],
    ['large', <Falcon key={1} icon="minus" $size={12}/>],
]);
const checkIconMap = new Map([
    ['small', <Falcon key={0} icon="check" $size={8}/>],
    ['large', <Falcon key={1} icon="check" $size={12}/>],
]);
export const Checkbox = forwardRef((props, forwardedRef) => {
    const { id: controlledId, invalid = false, label, indeterminate = false, required = false, $size = 'small' } = props, restProps = __rest(props, ["id", "invalid", "label", "indeterminate", "required", "$size"]);
    const autoId = useGeneratedId('textinput');
    const id = controlledId || autoId;
    const inputRef = useRef(undefined);
    const ref = useForkedRef(forwardedRef, inputRef);
    useEffect(() => {
        if (inputRef.current && indeterminate !== undefined) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    const Wrapper = label ? Container : FragmentWithoutProps;
    return (<Wrapper>
      <InputContainer $hasLabel={label !== undefined} $size={$size}>
        <Input {...restProps} type="checkbox" id={id} ref={ref} required={required} $invalid={invalid}/>
        <StyledOverlay $invalid={invalid}>
          {indeterminate ? minusIconMap.get($size) : checkIconMap.get($size)}
        </StyledOverlay>
      </InputContainer>
      {label && <Label htmlFor={id}>{label}</Label>}
    </Wrapper>);
});
